export default __webpack_public_path__ + "static/media/undraw_Credit_card_re_blml 1.a1db8438.svg";